import { render, staticRenderFns } from "./txPair.vue?vue&type=template&id=2e5a148f&scoped=true&"
import script from "./txPair.vue?vue&type=script&lang=js&"
export * from "./txPair.vue?vue&type=script&lang=js&"
import style0 from "./txPair.vue?vue&type=style&index=0&id=2e5a148f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5a148f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5a148f')) {
      api.createRecord('2e5a148f', component.options)
    } else {
      api.reload('2e5a148f', component.options)
    }
    module.hot.accept("./txPair.vue?vue&type=template&id=2e5a148f&scoped=true&", function () {
      api.rerender('2e5a148f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/head/txPair.vue"
export default component.exports